import { useCallback } from 'react';

import { useGlobal } from '~/hooks/useGlobal';
import { userStore } from '~/stores';
import { notSSRFormatPriceWithCurrency } from '~/utils/formaters';

/**
 * `formatPriceWithCurrency` bound to the current language. That helper reads
 * the global context on every call, so a component calling it a varying
 * number of times changes its hook order between renders; this hook reads
 * the context once and returns a plain formatter.
 */
export const usePriceFormatter = () => {
  const { serverLang } = useGlobal();
  const lang = import.meta.env.SSR ? serverLang : userStore.lang;

  return useCallback(
    (price: string | number = 0, currency?: string) =>
      notSSRFormatPriceWithCurrency(price, lang, currency),
    [lang],
  );
};
